import { render, staticRenderFns } from "./PaperShredderIcon.vue?vue&type=template&id=e446ba8a&scoped=true"
import script from "./PaperShredderIcon.vue?vue&type=script&lang=js"
export * from "./PaperShredderIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e446ba8a",
  null
  
)

export default component.exports